import { configureStore } from '@reduxjs/toolkit';
import appSlice from '../features/app/slice';
import { gladosApi } from '../api/glados';
import { listener } from './listener';
import { validationApi } from '@vfde-sails/validation';

export const store = configureStore({
    reducer: {
        [appSlice.reducerPath]: appSlice.reducer,
        [gladosApi.reducerPath]: gladosApi.reducer,
        [validationApi.reducerPath]: validationApi.reducer,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware()
            .prepend(listener.middleware) // listener goes first because of special actions in it
            .concat(
                gladosApi.middleware,
                validationApi.middleware,
            ),
});

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 */
export type RootState = ReturnType<typeof store.getState>;

/**
 * Infer AppDispatch
 */
export type AppDispatch = typeof store.dispatch;

/**
 * Hook-like function to dispatch actions
 */
export const useAppDispatch = () => store.dispatch;
